import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
          话题标签
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          当下最受关注的吃瓜话题，点击探索更多相关内容
        </p>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-center gap-3 px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="flex items-center gap-1.5">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  {topic.name}
                </span>
                <span className="text-[10px] text-foreground-400 bg-background-200 px-1.5 py-0.5 rounded whitespace-nowrap">
                  {topic.count}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <div className="w-16 h-1.5 rounded-full bg-secondary-100 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-accent-500"
                    style={{ width: `${topic.heat}%` }}
                  ></div>
                </div>
                <span className="text-[10px] text-foreground-400 whitespace-nowrap">{topic.heat}°</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}